define([], () => ({
  RECEIVE_SHOPIFY_PRODUCTS: 'RECEIVE_SHOPIFY_PRODUCTS',
  RECEIVE_SHOPIFY_COLLECTIONS: 'RECEIVE_SHOPIFY_COLLECTIONS',
}));

